import { createUseMutationHook } from './createUseMutationHook';

export const useEditTravelPolicy = createUseMutationHook(
    'edit_travel_policy',
    travelPolicyId => [
        ['get_travel_policy_detailed', travelPolicyId],
    ],
);
